<template>
  <div id="app">
    <div class="home">
      <navbar/>
    <!-- component matched by router renders under router-view -->
    <router-view/> 
  </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  components: {
    'navbar': Navbar
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#logo {
  max-height: 55px;
}

.header {
  margin-bottom: 3em;
  background-color: #375890;
  color: #f8f9fa;
}

.navbar a, .navbar a:hover{
  color: #f8f9fa;
  text-decoration: none;
}

.no-underline, .no-underline:hover {
  text-decoration-line: none;
}

.search-wrap {
  width: 55%;
  margin-bottom: 2em;
}

.search-input {
  padding-left: 1em;
  border: 1px solid rgba(0,0,0,0.15);
}

.search-box {
  font-size: 22px;
  width: 100%;
  border: none;
  height: 40px;
}

.search-box:focus {
  outline-style: none;
}

.search-autocomplete {
  font-size: 22px;
  margin-top: 0px;
  border: 0.5px solid #d0d0d0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow: hidden;
  overflow-y: auto;
  position: absolute;
  z-index: 25;
  width: 100%;
  background: #ffffff;
  cursor: pointer;  
}

.search-result:hover {
  background: #f7f7f7;
}

/* CSS transition animations */
.fade-enter{
  opacity: 0;  
}

.fade-enter-active {
  transition: opacity 0.8s;
}

.clickable {
  cursor: pointer;
}

#studentIndex {
  padding: 0.2em;
}

#studentIndex:hover {
  font-weight: bold;
}

/* custom modal */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/* Modal transition effects */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* expand search bar on small devices */
@media (max-width: 575.98px) { 
  .search-wrap {width: 95%;}
  .search-autocomplete {width: 100%;}
  .modal-container {width: 300px;}
}

</style>
